import { render } from "./FavoritesDialog.vue?vue&type=template&id=ce235efe&scoped=true"
import script from "./FavoritesDialog.vue?vue&type=script&lang=js"
export * from "./FavoritesDialog.vue?vue&type=script&lang=js"

import "./FavoritesDialog.vue?vue&type=style&index=0&id=ce235efe&scoped=true&lang=css"

import exportComponent from "D:\\Microsoft VS Code Project\\mft_stock_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce235efe"]])

export default __exports__